import cx from 'classnames';
import { ITEM_SELECTION_STATUS } from 'utils/multiDimensionalListUtils';

interface SelectionIndicatorProps {
  status: string;
}

export const SelectionIndicator = ({ status }: SelectionIndicatorProps): React.ReactElement => (
  <span
    className={cx('h-1 w-1 bg-primary inline-block rounded-full mr-1.5', {
      invisible: status === ITEM_SELECTION_STATUS.UNCHECKED,
    })}
  />
);
